import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ToastContainer } from 'react-toastify';
import { IntercomWrap } from '../../components';
import { SocketProvider } from '../socket';
import { AuthProvider } from '../auth';
import { Theme } from '../theme/provider';
import { NotFound } from '../../../app/pages/notFound/NotFound';
import { NotificationsProvider } from '../notifications/provider';

export const AppProvider = ({ children }: any) => {
  return (
    <Theme>
      <ErrorBoundary
        FallbackComponent={NotFound}
        onReset={() => (window.location.href = '/home')}
      >
        <AuthProvider>
          <SocketProvider>
            <NotificationsProvider>
              <IntercomWrap>{children}</IntercomWrap>
              <ToastContainer style={{ minWidth: 492 }} />
            </NotificationsProvider>
          </SocketProvider>
        </AuthProvider>
      </ErrorBoundary>
    </Theme>
  );
};
